<template>
  <div
    class="form-section-separator"
    :class="`margin-${marginSize}`"
    :style="style">
    <div class="line" />
    <div
      v-show="hasIcon"
      class="icon">
      <slot name="icon" />
    </div>
    <div class="text">
      <slot />
    </div>
    <div class="line" />
  </div>
</template>

<script>
  export default {
    props: {
      opacity: {
        type: String, // e.g.: '50%'
        default: null,
      },
      color: {
        type: String,
        default: null,
      },
      marginSize: {
        type: String,
        default: 'md', // 'xs', 'sm', 'md' or 'none'
      },
    },
    computed: {
      hasIcon() {
        return !!this.$slots.icon;
      },
      style() {
        let style = '';
        if (this.opacity != null) {
          style = `${style}opacity: ${this.opacity};`;
        }
        if (this.color != null) {
          style = `${style}color: ${this.color};`;
        }
        return style;
      },
    },
  };
</script>

<style scoped lang="scss">
  @use '@/styles/variables' as *;

  .form-section-separator {
    color: var(--iconColorDark);
    opacity: 0.5;
    text-transform: uppercase;
    font-weight: 700;
    display: flex;
    margin: 3rem 2rem;

    &.margin-none {
      margin: 0;
    }

    &.margin-sm {
      margin: 2rem 1rem;
    }

    &.margin-xs {
      margin: 0rem 1rem;
    }

    .icon {
      margin: auto auto auto 1rem;
      height: 2.4rem;
      width: 2.4rem;
      fill: var(--iconColorDark);
      stroke: var(--iconColorDark);
    }

    .text {
      margin: auto 1rem;
    }

    .line {
      border-top: 0.1rem solid var(--iconColorDarkFaded80);
      flex: 1 0 20%;
      margin: auto;
    }
  }
</style>
